import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoPowerBizzHeader from "../../../assets/images/logo/logoPowerBizzHeader.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { HashLink } from "react-router-hash-link";
import TagManager from "react-gtm-module";
import usericon from "../../../assets/images/icon/user.svg";

const Menu = () => {
    const [navIsOpen, setNavIsOpen] = useState(false);

    const handleClick = (eventName) => {
        TagManager.dataLayer({
            dataLayer: {
                event: eventName,
            },
        });
    };
    const handleButtonClick = (category, action, label) => {
        TagManager.dataLayer({
            dataLayer: {
                event: category,
                category: category,
                action: action,
                label: label,
            },
        });
    };
    return (
        <ul className="navbar-nav ">
            <li className="d-block d-lg-none ">
                <div
                    className="logo"
                    onClick={() =>
                        handleButtonClick("Header", "clic en boton", "Home PowerBizz")
                    }
                >
                    <Link to="/">
                        <LazyLoadImage
                            src={logoPowerBizzHeader}
                            alt="brand identity"
                            width="127"
                        />
                    </Link>
                    <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                    ></span>
                </div>
            </li>
            <li className="nav-item  dropdown mega-dropdown">
                <button className="nav-link">
                    <HashLink to="/#contact-us" onClick={() => handleClick("Contáctanos")}>
                        <span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            Contáctanos
                        </span>
                    </HashLink>
                </button>
            </li>
            <li className="nav-item  dropdown mega-dropdown">
                <button className="nav-link">
                    <HashLink to="/#plans" onClick={() => handleClick("Planes")}>
                        <span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            Planes
                        </span>
                    </HashLink>
                </button>
            </li>
            <li className="nav-item dropdown mega-dropdown-sm">
                <button className="nav-link">
                    <HashLink to="/#section-two" onClick={() => handleClick("Beneficios")}>
                        <span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            Beneficios
                        </span>
                    </HashLink>
                </button>
            </li>
            {/* <li className="nav-item dropdown mega-dropdown-md">
    <button className="nav-link-login">
     <a
      target={"_blank"}
      href="https://panel.powerbizz.com/"
      onClick={() => handleClick("Iniciar Sesión")}
     >
      <span data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
       Iniciar Sesión
      </span>
     </a>
    </button>
   </li> */}
            <li className="d-block d-lg-none pt-10 lg:pt-0">
                <div >
                    <a href={'https://panel.powerbizz.com'} target="_blank" className="flex  items-center gap-2" >
                        <LazyLoadImage
                            src={usericon}
                            alt="user"
                        />
                        <label className="nav-link-login" >Iniciar sesión</label>
                    </a>
                </div>
            </li>
            <li className="d-block d-lg-none pt-10 lg:pt-0">
                <div
                    className="flex gap-2"
                >
                    <Link to="/nueva-tienda" className="nav-link-login" style={{ fontFamily: 'avenirblack', color: '#8163FF', border: '2px solid #8163FF', padding: 5 }}>
                        Crear tienda
                    </Link>
                    <span
                        data-bs-toggle="collapse"
                        data-bs-target=".navbar-collapse.show"
                    ></span>
                </div>
            </li>
        </ul >
    );
};

export default Menu;
